import React from 'react';
import { connect } from 'react-redux';
import Txt from '../../../inputs/textInput.js';
import Lbl from '../../../inputs/label.js';
import objectAssign from 'object-assign';
import { updateWaitingAreaForm } from '../../../../actions/waitingArea.js';
import { ValidMe } from '../../../../businessLogic/validation.js';
import { NetworkTypes } from '../../../../constants/networkTypes.js';
@connect()
export default class CenterPanelUpdate extends React.Component {
  constructor(props) {
    super(props);
  }

  waitingAreaUpdated = (property, value) => {
    let updatedwaitingAreaForm = objectAssign({}, this.props.waitingAreaForm, { [property]: value });
    return updatedwaitingAreaForm;
  };

  waitingAreaNameChanged = (value) => {
    this.props.dispatch(updateWaitingAreaForm(this.waitingAreaUpdated('name', value)));
  };
  waitingAreaDescriptionChanged = (value) => {
    this.props.dispatch(updateWaitingAreaForm(this.waitingAreaUpdated('shortDescription', value)));
  };

  render() {
    return (
      <span>
        <div className="ui form">
          <div className="pdtm">
            <ValidMe
              validmefor="length@3-50"
              validmemessage={APP.LANGUAGE.Errors.WaitingAreaInValidNameLength}
              group="updatewaitingAreaForm"
            >
              <Txt
                focusme="true"
                tabIndex="1"
                noTitle
                value={this.props.waitingAreaForm.name}
                maxLength={50}
                onChange={this.waitingAreaNameChanged}
                placeholder={APP.LANGUAGE.WaitingAreaGeneralInfo.NamePlaceholder}
              />
            </ValidMe>
            <ValidMe
              validmefor="required"
              validmemessage={APP.LANGUAGE.Errors.WaitingAreaInValidDescriptionLength}
              group="updatewaitingAreaForm"
            >
              <Txt
                tabIndex="1"
                noTitle
                value={this.props.waitingAreaForm.shortDescription}
                maxLength={200}
                fieldClasses="input mrbnull"
                onChange={this.waitingAreaDescriptionChanged}
                placeholder={APP.LANGUAGE.WaitingAreaGeneralInfo.DescriptionPlaceholder}
              />
              <div className="mrbm placeholder-label">
                <span>{APP.LANGUAGE.WaitingAreaGeneralInfo.DescriptionHint}</span>
              </div>
            </ValidMe>
          </div>
          <div>
            {this.props.waitingAreaForm.networkTypeId === NetworkTypes.WaitingArea
              ? APP.LANGUAGE.WaitingAreaGeneralInfo.RegularConsultationsDescription
              : APP.LANGUAGE.WaitingAreaGeneralInfo.GroupConsultationsDescription}
            <div className="mrbm placeholder-label">
              <span>{APP.LANGUAGE.WaitingAreaGeneralInfo.ConsultationsDescriptionHint}</span>
            </div>
          </div>
          <div className="mrbs hide-on-small-ress " />
        </div>
      </span>
    );
  }
}
